<template>
  <div class="day-selector" :class="[selected.duration, {isSearch: selected.isSearch}]">
    <div class="overflow-container">
      <div class="slider">
        <div
          v-for="(day, idx) in dayList"
          :key="`day-box-${idx}`"
          class="day-box"
          :class="[{selected: day.selected}, `diff-${day.diff}`]"
          @click="onClickDay(day)"
        >
          <div class="box-rendering">
            <template v-if="selected.duration == 'day' && !selected.isSearch">
              <h1>{{ day.day }}</h1>
              <h4>{{ day.weekDay }}</h4>
              <h5>{{ events.length }} {{ $filters.translate('T_EVENTS') }}</h5>
            </template>
            <template v-else>
              <h1 v-if="selected.isSearch">
                {{ $filters.translate('T_SEARCH_RESULT') }}
              </h1>
              <h1 v-else>
                {{ getWeekText() }}
              </h1>
            </template>
          </div>
          <div class="arrow arrow-down" />
        </div>
      </div>
    </div>

    <template v-if="!selected.isSearch">
      <div class="button-previous" @click="onClickPrevious()">
        <div class="arrow arrow-left" />
      </div>
      <div class="button-next" @click="onClickNext()">
        <div class="arrow arrow-right" />
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import Base from '@/components/Base'

export default {
  mixins: [
    Base
  ],
  props: [
    'selected',
    'events'
  ],
  data () {
    return {
      maxDay: 11,
      dayList: []
    }
  },
  async mounted () {
    this.updateDayList()
  },
  methods: {
    async updateDayList () {
      this.dayList = _.map(_.range(this.maxDay), idx => {
        const diff = idx - Math.floor(this.maxDay / 2)
        const boxDate = moment(this.selected.date).add(diff, 'd')
        return {
          diff,
          selected: diff === 0,
          date: boxDate.format('YYYY-MM-DD'),
          day: boxDate.format('D'),
          weekDay: this.$filters.translate(`T_WEEK_DAY_${boxDate.weekday()}`),
          numOfEvents: 0
        }
      })
    },
    onClickPrevious () {
      const diff = this.selected.duration === 'day' ? 1 : 7
      const newDate = moment(this.selected.date).add(-1 * diff, 'd').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    },
    onClickNext () {
      const diff = this.selected.duration === 'day' ? 1 : 7
      const newDate = moment(this.selected.date).add(1 * diff, 'd').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    },
    onClickDay (day) {
      _.set(this.selected, 'date', day.date)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    },
    getWeekText () {
      const weekStart = moment(this.selected.date).startOf('week')
      const weekEnd = moment(weekStart).add(6, 'd')
      return [
        this.getDateText(weekStart),
        this.getDateText(weekEnd)
      ].join(' - ')
    }

  }
}
</script>

<style lang="scss" scoped>
@import './DaySelector.scss';
</style>
